<template>
  <div class="list-box" id="huiwu_detail">
    <div class="flex items-center p-4">
      <div class="flex-1">
        <div class="flex items-center gap-x-3">
          <c_status
            arrName="Meeting_Status"
            showBg
            :value="state.model?.status"
            :key="state.model?.status"
          />
          <strong>{{ state.model?.name }}</strong>
          <text>{{ "[" + state.model?.number + "]" }}</text>
          <c_cell title="项目经理" class="ml-3">
            <template #default>
              <text>{{ state.model?.belonger_name }}</text>
              <text class="ml-1 text-xs text-gray-400">
                {{ state.model?.belonger_department_name }}
              </text>
            </template>
          </c_cell>
          <c_cell title="主办单位" :value="state.model?.sponsor"></c_cell>
          <c_cell title="承办单位" :value="state.model?.organizer"></c_cell>
          <el-icon color="var(--el-color-danger)">
            <LocationFilled />
          </el-icon>
          <text class="text-gray-400 text-sm" style="margin-left: -10px">
            {{
              state.model?.province +
              state.model?.city +
              state.model?.district +
              state.model?.address
            }}
          </text>
        </div>
        <div class="flex items-center mt-2 gap-x-5 flex-wrap gap-y-2">
          <c_cell
            title="会议日期"
            :value="state.model?.start_date + ' ~ ' + state.model?.end_date"
          ></c_cell>
          <c_cell title="会议天数" :value="state.model?.days + '天'"></c_cell>
          <c_cell
            title="报名开始时间"
            :value="
              $dayjs(state.model?.signup_start_time).format('YYYY-MM-DD HH:mm')
            "
          ></c_cell>
          <c_cell
            title="报名结束时间"
            :value="
              $dayjs(state.model?.signup_end_time).format('YYYY-MM-DD HH:mm')
            "
          ></c_cell>
          <c_cell title="住宿" :value="state.model?.accommodation"></c_cell>
          <c_cell title="用餐" :value="state.model?.catering"></c_cell>
          <c_cell
            title="单据抬头"
            class="flex-1"
            :value="state.model?.bill_title || '-'"
          ></c_cell>
        </div>
      </div>
    </div>
    <div
      class="flex-1 overflow-hidden gap-x-3 border-t grid"
      style="grid-template-columns: 160px 1fr"
    >
      <div class="overflow-y-auto my-2 px-2 flex flex-col gap-y-1">
        <ul
          v-for="item in menus"
          :key="item"
          class="flex items-center gap-x-3 p-3 text-sm rounded cursor-pointer hover:bg-gray-100 text-gray-400"
          :class="
            state.menu == item.name ? 'bg-blue-50 font-bold text-gray-900' : ''
          "
          @click="state.menu = item.name"
        >
          <el-image
            v-if="item.icon.includes('icon-')"
            :src="getImgSrc(item.icon)"
            style="width: 14px; height: 14px"
          />
          <el-icon v-else>
            <component :is="item.icon" />
          </el-icon>
          <text>{{ item.name }}</text>
        </ul>
      </div>
      <div class="h-full pt-2.5 rounded-lg overflow-hidden">
        <c_more
          :model="state.model"
          v-if="state.menu == '会议信息' && state.model?.id"
        />
        <c_baoming
          :meeting_id="state.model?.id"
          v-if="state.menu == '报名审核' && state.model?.id"
          @refresh="onLoad"
        />
        <c_qiandao
          :meeting_id="state.model?.id"
          v-if="state.menu == '签到管理' && state.model?.id"
        />
        <c_renyuan
          :meeting_id="state.model?.id"
          v-if="state.menu == '参会人员' && state.model?.id"
        />
        <c_jiesong
          :meeting_id="state.model?.id"
          v-if="state.menu == '接送管理' && state.model?.id"
        />
        <c_dajiaotong
          :meeting_id="state.model?.id"
          v-if="state.menu == '大交通管理' && state.model?.id"
        />
        <c_fenfang
          :meeting_id="state.model?.id"
          v-if="state.menu == '分房管理' && state.model?.id"
        />
        <c_jiucan
          :meeting_id="state.model?.id"
          v-if="state.menu == '就餐管理' && state.model?.id"
        />
        <c_duanxin
          :meeting_id="state.model?.id"
          v-if="state.menu == '短信管理' && state.model?.id"
        />
        <c_wuliao
          :meeting_id="state.model?.id"
          v-if="state.menu == '物料管理' && state.model?.id"
        />
        <c_rizhi
          :meeting_id="state.model?.id"
          v-if="state.menu == '会议日志' && state.model?.id"
        />
        <c_404 v-if="state.menu == '404'" />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

import {
  meeting_detail,
  meeting_cancel,
  meeting_startPrepare,
  meeting_accountingCancel,
} from "@/http/meeting";
import { ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";

import c_more from "./Detail/More.vue";
import c_baoming from "./Detail/BaoMing/List.vue";
import c_qiandao from "./Detail/QianDao/List.vue";
import c_renyuan from "./Detail/RenYuan/List.vue";
import c_jiesong from "./Detail/JieSong/Index.vue";
import c_dajiaotong from "./Detail/DaJiaoTong/List.vue";
import c_fenfang from "./Detail/FenFang/Index.vue";
import c_jiucan from "./Detail/JiuCan/List.vue";
import c_duanxin from "./Detail/DuanXin/List.vue";
import c_wuliao from "./Detail/WuLiao/List.vue";
import c_rizhi from "./Detail/RiZhi/List.vue";

import c_404 from "../Home/404.vue";

export default {
  props: {
    data: Object,
  },
  components: {
    c_more,
    c_baoming,
    c_qiandao,
    c_renyuan,
    c_jiesong,
    c_dajiaotong,
    c_fenfang,
    c_jiucan,
    c_duanxin,
    c_wuliao,
    c_rizhi,
    c_404,
  },
  setup(props) {
    const menus = [
      { name: "会议信息", icon: "Document" },
      { name: "报名审核", icon: "Select" },
      { name: "签到管理", icon: "EditPen" },
      { name: "参会人员", icon: "User" },
      { name: "接送管理", icon: "icon-jiesong" },
      { name: "大交通管理", icon: "icon-dajiaotong" },
      { name: "分房管理", icon: "icon-fenfang" },
      { name: "就餐管理", icon: "KnifeFork" },
      { name: "短信管理", icon: "icon-duanxin" },
      { name: "物料管理", icon: "icon-wuliao" },
      { name: "会议日志", icon: "Tickets" },
    ];
    //操作按钮显示的状态
    const btn_status = {
      kaishichoubei: [0], //开始筹备    策划中
      quxiao: [0], //取消会议  策划中
      tijiaohesuan: [3, 5], //提交核算  已结束、不通过
      quxiaohesuan: [6], //取消核算  已核算
    };
    const state = reactive({
      menu: "会议信息",
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      meeting_detail(props.data.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data?.data || {};
        }
      });
    };

    //开始筹备
    const onChouBei = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-success);">开始筹备</strong>该会议吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_startPrepare(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    //取消会议
    const onQuXiao = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: #a2a2a2">取消</strong>该会议吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_cancel(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    //提交核算
    const onHeSuan = () => {
      state.showHeSuan = true;
    };

    //取消核算
    const onQuXiaoHeSuan = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">取消核算</strong>吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_accountingCancel(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    const getImgSrc = (iconName) => {
      // require必须写完整静态路径片段，webpack才能解析
      return require(`@/assets/images/${iconName}.png`);
    };

    return {
      state,
      props,
      menus,
      onLoad,
      btn_status,
      onChouBei,
      onQuXiao,
      onHeSuan,
      onQuXiaoHeSuan,
      getImgSrc,
    };
  },
};
</script>

<style lang="less" scoped></style>
